<template>

  <HeaderSection />

  <section id="formulario" class="bg-[#153244] py-10" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 w-full md:max-w-6xl bg-white rounded-lg p-10">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center ">
          PREACREDITACIÓN DE VISITANTES
        </h1>
        <h1 class="text-gray-800 text-center">
          Si ya se acreditó y no le llegó el correo puede descargar su QR haciendo <router-link to="/credenciales" class="underline">click aquí</router-link>
        </h1>
        <h1 class="text-gray-800 text-2xl text-center mt-5">
          Por favor complete el formulario en su totalidad
        </h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">DNI</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric" @blur="validarDni" placeholder="DNI"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text"  placeholder="Nombre"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text"  placeholder="Apellido"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text"  placeholder="Mail"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Web Site</label>
            <Field name="webSite" v-slot="{ field, errors }" v-model="formData.webSite">
              <InputText v-bind="field" type="text"  placeholder="Web site"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="webSite" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País (celular)</label>
              <Select v-model="selectedCountry" :options="paises" optionLabel="descripcion" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.id" class="input-base input-success"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Invitado por</label>
            <Field name="invitadoPor" v-slot="{ field, errors }" v-model="formData.invitadoPor">
              <InputText v-bind="field" type="text"  placeholder="Invitado por (puede dejar este campo vacío)"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="invitadoPor" /></span>
            </Field>
          </div>
        </div>


        <h1 class="font-bold text-gray-800 text-2xl text-center pt-8 pb-5 ">
          DATOS DE LA EMPRESA
        </h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Razón social</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Empresa" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" placeholder="Cargo" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Calle</label>
            <Field name="calle" v-slot="{ field, errors }" v-model="formData.calle">
              <InputText v-bind="field" type="text"  placeholder="Calle"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="calle" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Número</label>
            <Field name="numero" v-slot="{ field, errors }" v-model="formData.numero">
              <InputText v-bind="field" type="text"  placeholder="Número" class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numero" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Piso</label>
            <Field name="piso" v-slot="{ field, errors }" v-model="formData.piso">
              <InputText v-bind="field" type="text"  placeholder="Piso" class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="piso" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Departamento</label>
            <Field name="departamento" v-slot="{ field, errors }" v-model="formData.departamento">
              <InputText v-bind="field" type="text"  placeholder="Departamento" class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="departamento" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">C.P.</label>
            <Field name="cp" v-slot="{ field, errors }" v-model="formData.cp">
              <InputText v-bind="field" type="text"  placeholder="C.P." class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cp" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País</label>
            <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.pais">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="País" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="pais" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provinciaArgentina" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provinciaArgentina">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaArgentina" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provincia">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su provincia o estado"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaEstado" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Localidad / Ciudad</label>
            <Field name="localidad" v-slot="{ field, errors }" v-model="formData.localidad">
              <InputText v-bind="field" type="text"  placeholder="Localidad" class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Actividad de la empresa</label>
            <Field name="actividadEmpresa" v-slot="{ field, errors }" v-model="formData.actividadEmpresa">
              <InputText v-bind="field" type="text"  placeholder="Actividad de la empresa"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="actividadEmpresa" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-[#153244] hover:bg-[#153244] text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';

import suiteService, { Acreditado, EstadoAcreditado, StringIdLabelEntity, OrigenAcreditado, IdLabelEntity, TipoAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais  extends StringIdLabelEntity {}
interface Provincia extends IdLabelEntity {}

export default defineComponent({
  components: {
    HeaderSection,
    InputText,  BlockUI, Select, 
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "EXPOSEG 2025 - Acreditación";
  },
  data() {
    return {
      selectedCountry: {"id": "+54", "descripcion": "Argentina"} as Pais,
      paises: [] as Pais[],
      provincias: [] as Provincia[],
      isSubmitting: false,
      formData: {
        documento: '',
        nombre: '',
        apellido: '',
        empresa: '',
        cargo: '',
        calle: '',
        numero: '',
        piso: '',
        departamento: '',
        cp: '',
        localidad: '',
        provinciaEstado: '',
        provinciaArgentina: undefined as unknown as Provincia,
        pais: {"id": "+54", "descripcion": "Argentina"} as Pais,
        codigoArea: '',
        telefonoCelular: '',
        mail:  '',
        webSite: '',
        invitadoPor: '',
        actividadEmpresa: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese su DNI').min(6, 'Al menos 6 números'),
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido'),
        codigoArea: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el teléfono celular').matches(/^\d+$/, 'Solo se permiten números'),
        empresa: yup.string().required('Ingrese su empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingrese su cargo').min(3, 'Al menos 3 letras'),
        calle: yup.string().required('Ingrese la calle').min(3, 'Al menos 3 letras'),
        numero: yup.string().required('Ingrese el número').matches(/^\d+$/, 'Solo se permiten números'),
        cp: yup.string().required('Ingrese el código postal'),
        pais: yup.mixed().required('Seleccione su país'),
//        localidad: yup.string().required('Ingrese la localidad').min(3, 'Al menos 3 letras'),        
        actividadEmpresa: yup.string().required('Ingrese la actividad de la empresa'),

        provinciaArgentina: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function(value) {
          const paisSelected = this.parent.pais;     
          if(paisSelected?.id == '+54' && !value) {
              return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-estado', 'Ingrese la provincia / estado', function(value) {
          const paisSelected = this.parent.pais;
          if(paisSelected?.id != '+54' && !value) {
              return false;
          }
          return true;
        }),


      });
    }
  },
  methods: {
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
        if (acreditadoExistente) {
          this.isSubmitting = false;
          Swal.fire({ 
              title: "Atención", 
              html: "El DNI ingresado ya fue registrado.<br/><br/>Le enviamos un mail con su QR de accesos<br/><br/>Por favor revise su casilla de correo y de spam.<br/><br/>También puede descarga su QR haciendo <a href='/credenciales'>click aquí</a>",
              icon: "warning" }).then(() => {
                window.location.href = "https://www.exposegba.com.ar";
          });
          return;
        }
      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      console.log(values?.errors);
      Swal.fire({ title: "Error", html: "Por favor revise el formulario<br/>Hay error/es (" + errores + ")", icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        Swal.fire({ 
            title: "Atención", 
            html: "El DNI ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "warning" }).then(() => {
              window.location.href = "https://www.exposegba.com.ar";
        });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 1672 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.dni = this.formData.documento;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.mail = this.formData.mail;
      acreditado.telefono = this.selectedCountry.id + this.formData.codigoArea + this.formData.telefonoCelular;
      acreditado.empresa = this.formData.empresa;      
      acreditado.cargo = this.formData.cargo;
      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false;
      
      acreditado.dato1 = this.formData.webSite;
      acreditado.dato2 = this.formData.invitadoPor;
      acreditado.dato3 = this.formData.calle;
      acreditado.dato4 = this.formData.numero;
      acreditado.dato5 = this.formData.departamento;
      acreditado.dato6 = this.formData.piso;
      acreditado.dato7 = this.formData.cp;

      acreditado.dato8 = this.formData.pais?.descripcion;
      if(this.formData.pais?.id == '+54') {
        acreditado.dato9 = this.formData.provinciaArgentina?.descripcion;
      } else {
        acreditado.dato9 = this.formData.provinciaEstado;
      }
      acreditado.dato10 = this.formData.localidad
      acreditado.dato11 = this.formData.actividadEmpresa;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Estimado/a:<br>Hemos recibido sus datos de registración con éxito.<br/><br/>Le enviamos un mail con un enlace para descargar su credencial para concurrir al evento.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://www.exposegba.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.paises = jsonCountries;
    this.provincias = jsonProvincias;
  }
});
</script>
